// Trade Marketing survey questionnaire catalog.
// Kept in sync with the mobile app (shelf-app: app/asesor/stores/elements/PollQuestions.js).
// A survey record only stores answers keyed by `value` (e.g. "1.a"); this catalog maps
// those keys back to their section and question text so the admin can render the desplegable.

export const PollQuestions = [
    {
        title: '1. Preparación',
        questions: [
            { question: 'a) Cuenta con todas las herramientas para iniciar la labor de campo?', value: '1.a' },
            { question: 'b) Revisa ruta, objetivos e inventarios del dia antes de salir al campo?', value: '1.b' },
            { question: 'c) Planifica visita lògica por cliente ?', value: '1.c' },
        ],
    },
    {
        title: '2. Acercamiento',
        questions: [
            { question: 'a) Saluda y se identifica con su nombre y el de la empresa', value: '2.a' },
            { question: 'b) Es identificado con el cliente', value: '2.b' },
            { question: 'c) Rompe el hielo y escucha al cliente', value: '2.c' },
        ],
    },
    {
        title: '3. Distribución y Precios',
        questions: [
            { question: 'a) Revisa la distribucion de los productos que compra el cliente?', value: '3.a' },
            { question: 'b) Toma inventario de existencias y fallas ?', value: '3.b' },
            { question: 'c) Ajusta pedido sugerido en funcion de las necesidades del negocio?', value: '3.c' },
            { question: 'd) Verifica que los precios sean los acordados previamente?', value: '3.d' },
        ],
    },
    {
        title: '4. Gerencia del punto de venta',
        questions: [
            { question: 'a) Verifica que los productos esten en lugares preferenciales?', value: '4.a' },
            { question: 'b) Verifica rotacion de productos(primero en entrar primero en salir)?', value: '4.b' },
            { question: 'c) Verifica la planogramacion de las marcas claves?', value: '4.c' },
        ],
    },
    {
        title: '5. Cobranza',
        questions: [
            { question: 'a) Verifica deuda pendiente e informa al cliente?', value: '5.a' },
            { question: 'b) Cobranza proactiva,logra compromiso de pago ?', value: '5.b' },
        ],
    },
    {
        title: '6. Presentación',
        questions: [
            { question: 'a) Comenta al cliente las gestiones hechas en el punto de venta ?', value: '6.a' },
            { question: 'b) Ofrece al cliente pedido sugerido con entisiasmo y seguridad?', value: '6.b' },
            { question: 'c) Comunica las promociones existentes con entusiasmo y seguridad?', value: '6.c' },
            { question: 'd) Supera objeciones que presenta el cliente ?', value: '6.d' },
            { question: 'e) Recomienda precio sugerido al publico ?', value: '6.e' },
        ],
    },
    {
        title: '7. Cierre de Venta',
        questions: [
            { question: 'a) Sin muchas palabras,pide la aceptacion del pedido sugerido?', value: '7.a' },
            { question: 'b) Cierra la venta en el momento oportuno ?', value: '7.b' },
        ],
    },
    {
        title: '8. Aclarar fecha de entrega y forma de pago',
        questions: [
            { question: 'a) Cuantifica la venta y comunica al cliente ?', value: '8.a' },
            { question: 'b) Recuerda al cliente fecha de entrega ?', value: '8.b' },
        ],
    },
    {
        title: '9. Anotaciones',
        questions: [
            { question: 'a) Realiza anotaciones de la negociacion y objetivos proximos?', value: '9.a' },
            { question: 'b) Llena reporte diario de actividades ?', value: '9.b' },
        ],
    },
    {
        title: '10. Despedida',
        questions: [
            { question: 'a) Se despide adecuadamente mencionando el nombre del cliente ?', value: '10.a' },
            { question: 'b) Recuerda al cliente los compromisos hechos ?', value: '10.b' },
        ],
    },
    {
        title: '11. Aspectos Generales',
        questions: [
            { question: 'a) Puntualidad en la reunion diaria', value: '11.a' },
            { question: 'b) Al dia con los reportes diarios?', value: '11.b' },
            { question: 'c) Cumple con los pendientes de las minutas y control de asignaciones?', value: '11.c' },
            { question: 'd) Logra objetivos de las visitas?', value: '11.d' },
            { question: 'e) Mantiene la cartera de cobranza al dia?', value: '11.e' },
        ],
    },
    {
        title: '12. Aspecto Personal',
        questions: [
            { question: 'a) Aseo personal?', value: '12.a' },
            { question: 'b) Correctamente presentado/a?', value: '12.b' },
        ],
    },
];

// Total number of questions in the questionnaire (denominator for the score).
export const TOTAL_QUESTIONS = PollQuestions.reduce((sum, section) => sum + section.questions.length, 0);

// Flat lookup: question value -> { question, section }
export const QUESTION_BY_VALUE = PollQuestions.reduce((map, section) => {
    section.questions.forEach((q) => {
        map[q.value] = { question: q.question, section: section.title };
    });
    return map;
}, {});
